<template>
  <BaseDrawer v-model:isOpen="drawerState" :title="$t('studyInformation')">
    <section>
      <p v-if="purpose || purposeType">
        <span class="fw-semibold text-capitalize">{{ $t('purpose') }}:</span>
        {{ purposeText }}
      </p>
      <p v-if="desaturationRule">
        <span class="fw-semibold text-capitalize">{{ $t('desaturation') }}: </span>
        {{ $t('desaturationPanelLabel', { desaturation: desaturationRule }) }}
      </p>
      <p>
        <b class="fw-semibold text-capitalize">{{ $t('studyConfiguration') }}:</b>
        {{ $t(studyConfiguration) }}
      </p>
      <p>
        <b class="fw-semibold text-capitalize">{{ $t('sleepStudyRequestNote') }}:</b>
        {{ notes }}
      </p>
      <p v-if="ecgPolarityInversion">
        <span class="text-capitalize fw-semibold text-danger">! {{ $t('attention') }}:</span>
        {{ $t('studyInformationNote') }}
      </p>
    </section>

    <section>
      <p>
        <span class="fw-semibold text-capitalize">{{ $t('name') }}:</span> {{ fullName }}
      </p>
      <p>
        <span class="fw-semibold text-capitalize">{{ $t('dateOfBirth') }}:</span> {{ dateOfBirth }}
      </p>
      <p>
        <span class="fw-semibold text-capitalize">{{ $t('patientID') }}:</span> {{ patientID }}
      </p>
      <p>
        <span class="fw-semibold text-capitalize">{{ $t('studyID') }}:</span> {{ studyId }}
      </p>
    </section>
  </BaseDrawer>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { BaseDrawer } from '@/common/ui';
import { useGetMetadataInfo } from '@/common/utils';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'StudyMetadataPanel',
  components: { BaseDrawer },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:isOpen'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const {
      dateOfBirth,
      desaturationRule,
      fullName,
      patientID,
      purpose,
      purposeType,
      studyConfiguration,
      studyId,
      notes,
      ecgPolarityInversion
    } = useGetMetadataInfo();

    const drawerState = computed({
      get: () => props.isOpen,
      set: (val: boolean) => emit('update:isOpen', val)
    });

    const purposeText = computed(() => `${t(purpose.value)} ${t('for')} ${t(purposeType.value)}`);

    return {
      open,
      fullName,
      dateOfBirth,
      patientID,
      studyId,
      studyConfiguration,
      desaturationRule,
      emit,
      drawerState,
      ecgPolarityInversion,
      purpose,
      purposeType,
      purposeText,
      notes
    };
  }
});
</script>
